import _ from 'lodash';
import Vue from 'vue';

// import store from '@/store';

import BookingApi from '@/store/api/extensions/eventManager/booking';

// initial state
const state = {
    // selections: {}
    // ^^^^^^^^^^^^^^
    // active elements per page with page path as key
    // Example:
    // selections: [
    //     '/foo-bar': {
    //         event: {...},
    //         slot: {...},
    //     }
    // ]
    selections: {}

    // form: {
    //     event: undefined,
    //     slot: undefined,
    //     member: undefined,
    //     booker: {
    //         first_name: '',
    //         last_name: '',
    //         email: '',
    //         phone: '',
    //         terms: false
    //     },
    //     message: ''
    // }
};

// getters
const getters = {
    selections: state => state.selections
};

// mutations
const mutations = {
    selectEvent(state, { key, event }) {
        if (!state.selections[key]) Vue.set(state.selections, key, { event: undefined, slot: undefined });
        Vue.set(state.selections[key], 'event', event);
        Vue.set(state.selections[key], 'slot', undefined);
    },
    selectSlot(state, { key, slot }) {
        if (!state.selections[key]) Vue.set(state.selections, key, { slot: undefined, slot: undefined });
        Vue.set(state.selections[key], 'slot', slot);
    }
};

// actions
const actions = {
    createBooking({ commit, state }, payload) {
        return BookingApi.create(payload);
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
